module.exports = __webpack_public_path__ + "static/media/tic-tac-toe.3a090ab4.png";